/* eslint-disable max-lines-per-function */
import { useMemo } from 'react';

import {
   createDynamicColumnsWidth,
   InteractiveTable,
   InteractiveTableColumnConfiguration,
} from '@dreryk/react-components';

import { healthcareOrganizationTranslationKeys } from '../../../../translations';

import { ScopeOfProvidedServicesInteractiveTableBean } from './ScopeOfProvidedServicesInteractiveTable.types';
import { FunctionOfHealthcareAutosuggestCell } from './cells/FunctionOfHealthcareAutosuggestCell';
import { MedicalFieldAutosuggestCell } from './cells/MedicalFieldAutosuggestCell';

export const useScopeOfProvidedServicesColumns = (): InteractiveTableColumnConfiguration<ScopeOfProvidedServicesInteractiveTableBean>[] => {
   return useMemo(() => {
      const columnWidths = createDynamicColumnsWidth({
         functionOfHealthcare: '50%',
         medicalField: '50%',
         options: '24px',
      });

      return [
         {
            name: 'functionOfHealthcare',
            label: healthcareOrganizationTranslationKeys.resortCode.nine,
            width: columnWidths.functionOfHealthcare,

            renderer: ({ bean, index }) => (
               <FunctionOfHealthcareAutosuggestCell
                  testId={'functionOfHealthcare'}
                  name={'functionOfHealthcare'}
                  index={index}
                  defaultValue={bean.functionOfHealthcare}
               />
            ),
         },
         {
            name: 'medicalField',
            label: healthcareOrganizationTranslationKeys.resortCode.ten,
            width: columnWidths.medicalField,

            renderer: ({ bean, index }) => (
               <MedicalFieldAutosuggestCell
                  testId={'medicalField'}
                  name={'medicalField'}
                  index={index}
                  defaultValue={bean.medicalField}
               />
            ),
         },
         {
            name: 'options',
            width: columnWidths.options,

            renderer: ({ index, rowsCount }) => {
               if (rowsCount === 1) {
                  return null;
               }

               return <InteractiveTable.DeleteRowCell index={index} />;
            },
         },
      ];
   }, []);
};
